import { TourImagesRoute } from "@/modules/tours/routes/tour-images.route.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/$tourId/images")({
	component: TourImagesRoute,
});
